/**
 * Created by Alican Köker on 2019-05-28.
 */
import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { EdisonGameMode } from "../gameMode/EdisonGameMode";
import { EdisonGameConfig } from "../EdisonGameConfig";
import { GameResources } from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { IResizeData, StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { Orientation } from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import { EdisonHelper } from "../../utils/EdisonHelper";
import { TimelineLite, TweenLite } from "gsap";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { SpinEvent } from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { EdisonIndividualWPView } from "./individual/EdisonIndividualWPView";
import { ServerEvent } from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import { EdisonParsedGameData } from "../server/data/EdisonParsedGameData";
import { EdisonParsedInitData } from "../server/data/EdisonParsedInitData";
import { ScalableLayer } from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import { EdisonReelAreaView } from "../reel/EdisonReelAreaView";
import { EdisonGameModuleConfig } from "../EdisonGameModuleConfig";
import { EdisonBackground } from "../background/EdisonBackground";

export class EdisonWPView extends BaseView {

    private _layer:ScalableLayer;
    private _mainContainer:PIXI.Sprite;
    private _frameSpriteContainer:PIXI.Sprite;
    private _frameSpinesArr:PIXI.spine.Spine[];
    private _frames:PIXI.Sprite[];
    private _stackedFrames:PIXI.Sprite[];
    private _gameMode:EdisonGameMode = EdisonGameMode.NORMAL;
    private _WPTimeline:TimelineLite;
    private _portraitExtraTopPadding:number = 0;
    private _orientation:Orientation = Orientation.LANDSCAPE;
    private _modeChangeAnimTimeline:TimelineLite;
    private _isRestore:boolean = false;
    private _reelsStopped:boolean = true;

    private static _leftPadding:number = 76;
    private static _topPadding:number = 74;

    constructor() {
        super();
        this._layer = StageManager.getLayer(EdisonGameConfig.instance.LAYERS.WIN_PRESENTATIONS.name);
        this._frameSpinesArr = [];
        this._frames = [];
        this._stackedFrames = [];
        this._mainContainer = new PIXI.Sprite();
        this._layer.addChild(this._mainContainer);
        this._frameSpriteContainer = new PIXI.Sprite();

        EventHandler.addEventListener(this, SpinEvent.START, (event:GameEvent) => this.onSpinStart());
        EventHandler.addEventListener(this, SpinEvent.STOPPED, (event:GameEvent) => this._mainContainer.visible = true);
        EventHandler.addEventListener(this, EdisonIndividualWPView.SET_MODE, (event:GameEvent) => this.setGameMode(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    protected initAnimations():void {
        this.createVisuals();

    }


    protected onGameDataParsed(data:EdisonParsedGameData | EdisonParsedInitData):void {
        this._gameMode = data.nextMode;
        if(data instanceof EdisonParsedGameData) {
            this._isRestore = false;
        } else {
            this._isRestore = data.isRestoreState;
        }
    }

    private createVisuals():void {

        const noOfSymbolsOnReel:number = EdisonGameConfig.instance.SYMBOLS_NUM_IN_REEL[2];
        const noOfReels:number = EdisonGameConfig.instance.REELS_NUM;

        for(let i:number = 0; i < noOfReels; i++) {
            for(let j:number = 0; j < noOfSymbolsOnReel; j++) {

                let frameSpine:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("individualWinFrame"));
                let frame:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("wpFrame")[0]);
                if(j === 0) {
                    let stackedFrame:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("wpFrameStacked")[0]);
                    stackedFrame.scale.set(.865);
                    this._mainContainer.addChild(stackedFrame);
                    this._stackedFrames.push(stackedFrame);
                    stackedFrame.visible = false;
                }
                frame.scale.set(.86);
                frame.visible = false;
                this._mainContainer.addChild(frame);
                this._mainContainer.addChild(frameSpine);

                this._frameSpinesArr.push(frameSpine);
                this._frames.push(frame);
            }
        }
        this.repositionFrames();
    }

    private setGameMode(mode:string):void {
        this._gameMode = mode;
    }

    protected onResize?(resizeData:IResizeData):void {
        if(this._orientation === resizeData.orientation)
            return;

        if(this._modeChangeAnimTimeline && this._modeChangeAnimTimeline.isActive()) {
            this._modeChangeAnimTimeline.pause();
            this._modeChangeAnimTimeline.kill();
        }

        this._orientation = resizeData.orientation;

        this.repositionFrames();
    }

    private repositionFrames():void {

        this._portraitExtraTopPadding = this._orientation === Orientation.PORTRAIT ? -106 : 0;

        this._frameSpinesArr.forEach((frameSpine, index) => {
            const tlPos:number[] = EdisonHelper.getSymbolPosition(Math.floor(index / 3), index % 3);
            frameSpine.position.set(tlPos[0] + EdisonWPView._leftPadding, tlPos[1] + EdisonWPView._topPadding + this._portraitExtraTopPadding);
            this._frames[index].position.set(tlPos[0], tlPos[1] + this._portraitExtraTopPadding - 2);
        });

        this._stackedFrames.forEach((value, index) => {
            const tlPos:number[] = EdisonHelper.getSymbolPosition(index, 0);
            this._stackedFrames[index].position.set(tlPos[0], tlPos[1] + this._portraitExtraTopPadding - 2);
        });
    }

    public setFrameImage(index:number, stacked:boolean = false):void {
        let frame:PIXI.Sprite = stacked ? this._stackedFrames[Math.floor(index / 3)] : this._frames[index];
        if(frame.visible || !this._reelsStopped)
            return;

        frame.visible = true;
    }

    public playFrameOverlay(reelIndex:number, symbolIndex:number, initial:boolean = false, stacked:boolean = false):TimelineLite {
        this._WPTimeline = new TimelineLite();
            let animName:string = stacked ? "InitWinTall" : "InitWin";
            this._frameSpinesArr[reelIndex * 3 + symbolIndex].scale.set(stacked ? .96 : .96);

            this._WPTimeline.add(() => {
                let trackEntry = this._frameSpinesArr[reelIndex * 3 + symbolIndex].state.setAnimation(0, animName, false);
                trackEntry.timeScale = initial ? 1.3 : 1;
            });

        return this._WPTimeline;
    }

    private onSpinStart():void {
        this._reelsStopped = false;
        this.reset();
        EdisonGameModuleConfig.background.dimBackground(false);
        this._layer.alpha = 1;
    }

    public reset():void {

        if(this._WPTimeline) {
            this._WPTimeline.pause();
            this._WPTimeline.kill();
        }

        for(let i:number = 0; i < this._frameSpinesArr.length; i++) {
            if(this._frameSpinesArr[i]) {
                this._frameSpinesArr[i].state.clearTracks();
                this._frameSpinesArr[i].state.setEmptyAnimation(0, 0);
                this._frameSpinesArr[i].skeleton.setToSetupPose();
            }
        }

        this._frames.forEach((frame) => {
            frame.visible = false;
        });

        this._stackedFrames.forEach((frame) => {
            frame.visible = false;
        });

        EdisonGameModuleConfig.background.changeReelBackground(this._gameMode.toString().toLowerCase());
    }

    public resetAnimations():void {

        if(this._WPTimeline) {
            this._WPTimeline.pause();
            this._WPTimeline.kill();
        }

        for(let i:number = 0; i < this._frameSpinesArr.length; i++) {
            if(this._frameSpinesArr[i]) {
                this._frameSpinesArr[i].state.clearTracks();
                this._frameSpinesArr[i].state.setEmptyAnimation(0, 0);
                this._frameSpinesArr[i].skeleton.setToSetupPose();
            }
        }
    }

    public set reelsStopped(value:boolean) {
        this._reelsStopped = value;
    }
}